class KeyValueModel {
    constructor(key, value) {
      this.key = key;
      this.value = value;
    }
  
    static fromJson(json) {
      if (typeof json === "string") {
        try {
          json = JSON.parse(json);
        } catch (error) {
          throw new Error("Invalid JSON string");
        }
      }
      
      if (typeof json !== "object" || json === null) {
        throw new Error("Invalid JSON format");
      }
  
      return new KeyValueModel(String(json.key), String(json.value));
    }
  }
  
  export default KeyValueModel;
  